import { BrightcovePlayer } from '@brightcove/react-player-loader';

import { ExtendedBrightcovePlayer } from '../../types';

export function isExtendedPlayer(
  player: BrightcovePlayer | ExtendedBrightcovePlayer | any,
): player is ExtendedBrightcovePlayer {
  if (typeof player.consumedSeconds === 'function') {
    return true;
  }
  return false;
}
